import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";

// components
import { DrawerCollection } from "components/NewSearch/DrawerCollection";
import NewSearchHeighlights from "../RightSide/NewSearchHeighlights";
import { HomeSearchCard } from "components/NewHomePage/HomeSearchCard";
import { Breadcrumb } from "./BreadCrumbs";
import CardContainer from "./CardContainer";
import { NameAndSortBy } from "./NameAndSortBy";
import { SearchPageCard } from "./SearchPageCard";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";
import { useSearchQuery } from "customHooks/useQuery";

// helpers
import { goAxiosInstance } from "helpers/axiosInstance";

// style
import "./styles.scss";
import Modal from "components/LoginAndRegister/Modal";

export const MiddleSide = ({ isVillas = "villas" }: any) => {
	const [showDrawer, setShowDrawer] = useState(false);

	const width = useMediaQuery();
	const { pathname } = useLocation();
	const query = useSearchQuery();

	const isLaptopOrLower = width < 500 ? true : false;

	const locationName =
		(pathname === "/search" &&
			window.location?.search?.split("=")[1]?.split("&")[0]) ||
		(window.location.pathname.split("/")[1] === isVillas &&
			window.location?.pathname?.split("/")[2].split("-")[2]);

	const lat = query.get("lat")
		? query.get("lat")
		: // @ts-ignore
		JSON.parse(localStorage.getItem("location"))?.lat
		? // @ts-ignore
		  JSON.parse(localStorage.getItem("location"))?.lat
		: "";

	const lon = query.get("lon")
		? query.get("lon")
		: // @ts-ignore
		JSON.parse(localStorage.getItem("location"))?.lon
		? // @ts-ignore
		  JSON.parse(localStorage.getItem("location"))?.lon
		: "";

	const highlightData = useQuery(
		["highlight", query?.get("lat"), query?.get("lon"), locationName],
		() => {
			return goAxiosInstance({
				method: "get",
				url: `hightlight?lat=${
					// @ts-ignore
					parseFloat(query?.get("lat")) ? parseFloat(query?.get("lat")) : ""
				}&lon=${
					// @ts-ignore
					parseFloat(query?.get("lon")) ? parseFloat(query?.get("lon")) : ""
				}&location=${
					// @ts-ignore
					!parseFloat(query?.get("lat")) && !parseFloat(query?.get("lon"))
						? locationName
						: ""
				}`,
			});
		},
		{
			enabled:
				window.location.pathname?.split("/")[1] === isVillas ||
				pathname === "/search"
					? true
					: false,
			retry: false,
		},
	);

	const handleDrawer = (value: boolean): void => {
		setShowDrawer(value);
	};

	return (
		<div className="middle__side__container">
			<Breadcrumb />
			<NameAndSortBy handleDrawer={handleDrawer} />
			{highlightData?.data?.data?.data.length > 0 && (
				<NewSearchHeighlights data={highlightData?.data?.data?.data} />
			)}
			<Modal shouldShow={showDrawer} onRequestClose={() => handleDrawer(false)}>
				<DrawerCollection handleDrawer={handleDrawer} showDrawer={showDrawer} />
			</Modal>
			<CardContainer Card={isLaptopOrLower ? HomeSearchCard : SearchPageCard} />
		</div>
	);
};
